module.exports = __webpack_public_path__ + "static/media/mtgVid-min.c9d4662f.mp4";